module.exports = __webpack_public_path__ + "static/media/addIcon.c26c2376.svg";